import { render, staticRenderFns } from "./DocumentMobileBanner.vue?vue&type=template&id=2b727ec7&scoped=true&"
import script from "./DocumentMobileBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DocumentMobileBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DocumentMobileBanner.vue?vue&type=style&index=0&id=2b727ec7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b727ec7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b727ec7')) {
      api.createRecord('2b727ec7', component.options)
    } else {
      api.reload('2b727ec7', component.options)
    }
    module.hot.accept("./DocumentMobileBanner.vue?vue&type=template&id=2b727ec7&scoped=true&", function () {
      api.rerender('2b727ec7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/DocumentMobileBanner.vue"
export default component.exports